const checkIsImage = (contentType: string = '') => /image/ig.test(contentType);

export default checkIsImage;
